// This function allow to reference all chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + {"185":"cb679e23a14eac25","931":"6716a3fc248a1c3b"}[chunkId] + ".css";
};